import { createApp, provide, ref } from 'vue'
import pressList from '@/pages/in-the-press/press-list.vue'

createApp(pressList).mount('#press')